// extracted by mini-css-extract-plugin
export default {"name":"Field_name__dx0AG","nameWrapper":"Field_nameWrapper__Aq+jn","value":"Field_value__9-cR5","calculatedFieldInfo":"Field_calculatedFieldInfo__qmAEz"};